export default "__VITE_ASSET__NXs7yV$J__"